import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import * as React from "react";
import { Fragment, useState } from "react";
import {
  Button,
  useRefresh,
  useUnselectAll,
  useDataProvider,
} from "react-admin";
import SaveIcon from "@material-ui/icons/Save";
import { delay } from "utils/tools";
import TableResultConfirmAdhocFees from "./TableResultConfirmAdhocFees";

interface IBulkActionProps {
  selectedIds: number[];
  basePath: string;
  filterValues: any;
  label: string;
}

interface IResults {
  id: number;
  status: string;
}

const useStyles = makeStyles({
  actionColor: {
    color: "#FFF",
  },
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

const BulkActionRejectButton = ({ selectedIds }: IBulkActionProps) => {
  const [open, setOpen] = useState(false);
  const [finished, setFinished] = useState(false);
  const [results, setResults] = useState<IResults[]>([]);

  const refresh = useRefresh();
  const unselectAll = useUnselectAll();
  const provider = useDataProvider();
  const classes = useStyles();

  const selectedIdsWithStatus = selectedIds.map((id) => ({
    id,
    status: "Pending",
  }));

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    if (finished) {
      refresh();
    }

    setOpen(false);
  };

  const handleReject = (selectedId: IResults, index: number) => {
    provider
      .customUpdate(`subcontractorAdhocFees/${selectedId.id}/reject`, {
        data: {},
      })
      .then(() => {
        let tempInvoices = selectedIdsWithStatus;
        tempInvoices[index].status = "Success";
        setResults([...tempInvoices]);
      })
      .catch((err: any) => {
        let tempInvoices = selectedIdsWithStatus;
        tempInvoices[index].status = `Error, ${err.message}`;
        setResults([...tempInvoices]);
      });
  };

  const handleConfirm = async (selectedIdsWithStatus: IResults[]) => {
    selectedIdsWithStatus.forEach((selectedId) => {
      selectedId.status = "Loading...";
    });

    for (const selectedId of selectedIdsWithStatus) {
      const index = selectedIdsWithStatus.indexOf(selectedId);

      await handleReject(selectedId, index);
      await delay(2000);
    }

    await setFinished(true);
    await unselectAll("subcontractorAdhocFees");
  };

  return (
    <Fragment>
      <Button
        label={"Reject Selected"}
        onClick={handleOpen}
        style={{ backgroundColor: "#DA4040" }}
      />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          Reject Selected Adhoc Fees
        </DialogTitle>
        <DialogContent>
          {results.length > 0 ? (
            <TableResultConfirmAdhocFees records={results} />
          ) : (
            <DialogContentText color="initial">
              Are you sure you want to reject this selected adhoc fees with ID (
              {selectedIds.toString()})?
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          {!finished && (
            <Button
              onClick={() => handleConfirm(selectedIdsWithStatus)}
              color="primary"
              label="Confirm"
            >
              <SaveIcon />
            </Button>
          )}
          <Button
            onClick={handleClose}
            color="secondary"
            label={`${finished ? "Finish" : "Back"}`}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default BulkActionRejectButton;
